import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#333",
  "fill-rule": "evenodd",
  d: "M2.286 1.6c-.421 0-.762.359-.762.8v16.003c0 .442.34.8.762.8h1.93v1.6h-1.93C1.023 20.804 0 19.73 0 18.404V2.4C0 1.075 1.023 0 2.286 0h16.762c1.262 0 2.285 1.075 2.285 2.4v4.801h6.286L32 12.085v6.318c0 1.326-1.023 2.4-2.286 2.4h-1.523v-1.6h1.523c.421 0 .762-.358.762-.8V12.72l-3.515-3.918H19.81V2.4c0-.441-.342-.8-.762-.8zm7.723 17.603h12.597v1.6H10.01z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#333",
  "fill-rule": "evenodd",
  d: "M19.81 20.006V2.403h1.523v17.603zM5.333 20c0 1.325 1.024 2.4 2.286 2.4s2.286-1.075 2.286-2.4c0-1.326-1.024-2.401-2.286-2.401s-2.286 1.075-2.286 2.4m2.286-4.001c-2.104 0-3.81 1.79-3.81 4S5.516 24 7.62 24s3.81-1.791 3.81-4-1.706-4.001-3.81-4.001M23.62 20c0 1.325 1.023 2.4 2.285 2.4s2.286-1.075 2.286-2.4c0-1.326-1.023-2.401-2.286-2.401-1.262 0-2.286 1.075-2.286 2.4m2.285-4.001c-2.104 0-3.81 1.79-3.81 4S23.802 24 25.906 24s3.81-1.791 3.81-4-1.706-4.001-3.81-4.001",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }